import script from "./LeftSideBarDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeftSideBarDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./LeftSideBarDrawer.vue?vue&type=style&index=0&id=0b6468b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b6468b2"]])

export default __exports__